import template from './keresodoboz.pug';
import keresoServiceModule from '../kereso-service';
const MODULE_NAME = 'keresoDoboz';
class KeresoDobozController {
	constructor(keresoService) {
		'ngInject';
		this._keresoService = keresoService;
	}
	autoSuggest(term) {
		return this._keresoService.autoSuggest(term);
	}
	autoSuggestSelected() {
		this.kereses();
	}
	kereses(e) {
		if (e) {
			e.preventDefault();
		}
		window.location.href = `${this.keresoUrl}#?term=${this.model.term}`;
	}
	open(e) {
		e.preventDefault();
		this.openSearch = true;
	}
}

export default angular.module(MODULE_NAME, [keresoServiceModule])
	.component('keresoDoboz', {
		controller: KeresoDobozController,
		template: template(),
		bindings : {
			keresoUrl : '@'
		}
	}).name;



// WEBPACK FOOTER //
// ./source/applications/kereso/keresodoboz/keresodoboz.js